import React from "react";
import { Create as RaCreate, useTranslate } from "react-admin";
import { useHistory, useLocation } from "react-router-dom";
import { useFormStyles } from "../components/forms/useStyles";
import DuplicateForm from "./DuplicateForm";
import Form from "./Form";

const Create = (props) => {
	const translate = useTranslate();
	const classes = useFormStyles();
	const location = useLocation();
	const source = location?.search
		? JSON.parse(new URLSearchParams(location.search).get("source"))
		: [];
	const duplicateIds = source?.duplicateIds || [];
	const isDuplicateForm = duplicateIds.length > 0;
	const duplicateProps = {
		title: translate("resources.bookmaker-deals.bulk-actions.clone_all.title"),
	};
	const history = useHistory();
	const handleSuccess = (p) => {
		history.go(-1);
	};
	return (
		<RaCreate
			{...props}
			classes={classes}
			onSuccess={handleSuccess}
			{...(isDuplicateForm && duplicateProps)}
		>
			{isDuplicateForm ? (
				<DuplicateForm duplicateIds={duplicateIds} />
			) : (
				<Form />
			)}
		</RaCreate>
	);
};
export default Create;
